import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mindmap-compact-view",
  "use": "icon-mindmap-compact-view-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mindmap-compact-view\">\n<path d=\"M5 15L5 9C5 8.44772 5.44772 8 6 8L18 8C18.5523 8 19 8.44772 19 9L19 15C19 15.5523 18.5523 16 18 16L6 16C5.44772 16 5 15.5523 5 15Z\" stroke=\"#42526E\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol